import { create } from "zustand";
import { TProjectDetailsSidebar } from "../pages/ProjectDetailsPage/model/types/types";
import {
  ArticleIcon,
  ChatCircleTextIcon,
  CheckCircleIcon,
  DatabaseIcon,
  Icon,
  SparkleIcon
} from "@phosphor-icons/react";

export const sidebarOptions = [
  {
    value: "analysis",
    labelKey: "chapterHeader.aq",
    icon: CheckCircleIcon,
    titleKey: "chapterHeader.aqTitle",
    isLabs: false
  },
  {
    value: "intelligence-questions",
    labelKey: "chapterHeader.iq",
    icon: SparkleIcon,
    titleKey: "chapterHeader.iqTitle",
    isLabs: false
  },
  {
    value: "claims",
    labelKey: "chapterHeader.claims",
    icon: ArticleIcon,
    titleKey: "chapterHeader.claimsTitle",
    isLabs: false
  },
  {
    value: "comments",
    labelKey: "chapterHeader.comments",
    icon: ChatCircleTextIcon,
    titleKey: "chapterHeader.commentsTitle",
    isLabs: false
  },
  {
    value: "vault",
    labelKey: "chapterHeader.vault",
    icon: DatabaseIcon,
    titleKey: "chapterHeader.vaultTitle",
    isLabs: false
  }
] as const satisfies ReadonlyArray<{
  value: TProjectDetailsSidebar;
  labelKey: string;
  icon: Icon;
  titleKey: string;
  isLabs: boolean;
}>;

export type TSidebarOption = (typeof sidebarOptions)[number];

type TStore = {
  openSidebar: TProjectDetailsSidebar | null;
  openHandler: (name: TProjectDetailsSidebar | null) => void;
  isLabsTabOpen: () => boolean;
  closeHandler: () => void;
  toggleHandler: (name: TProjectDetailsSidebar | null) => void;
  scrollToBottomCallback: (() => void) | null;
  setScrollToBottomCallback: (callback: (() => void) | null) => void;
};

export const useProjectSidebarStore = create<TStore>((set, get) => ({
  openSidebar: null,
  scrollToBottomCallback: null,

  openHandler: (name) => set({ openSidebar: name }),
  isLabsTabOpen: () => sidebarOptions.find((option) => option.value === get().openSidebar)?.isLabs ?? false,
  closeHandler: () => set({ openSidebar: null }),
  toggleHandler: (name) => set((s) => ({ openSidebar: s.openSidebar === name ? null : name })),
  setScrollToBottomCallback: (callback: (() => void) | null) => set({ scrollToBottomCallback: callback })
}));
